module.exports = __webpack_public_path__ + "assets/media/4.7dd95200.wav";